import CommonEdit from "@/components/common/Edit";
import BranchForm from "../forms/BranchForm";
import { FC, useEffect, useState } from "react";
import { branchForm } from "@/utils/objects";
import { singleProp } from "@/interface/dataInterface";
import axios from "axios";
import { BASE_URL } from "@/config";
import axiosInstance from "@/utils/axiosInstance";

const BranchEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = useState(branchForm);

  useEffect(() => {
    const unsub = async () => {
      if (prop) {
        const response = await axiosInstance.get(`/branches/${prop}`);
        setFormProp(response.data);
      }
    };

    unsub();
  }, [prop]);

  return (
    <CommonEdit title="Edit" id={prop} resource="branches" data={formProp}>
      <BranchForm
        mode="edit"
        formProp={formProp}
        setFormProp={setFormProp}
      />
    </CommonEdit>
  );
};

export default BranchEdit;
